import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, Input, Select } from 'antd';

import ActionButtons from './actionButtons';

const { Option } = Select;

const ContactInfo = ({
  employee: { id: employeeID, contact } = {},
  onContactInfoUpdate,
  ability,
}) => {
  const [form] = Form.useForm();
  const [isFormReadOnly, setIsFormReadOnly] = useState(
    (contact && contact.phone_1) || !ability.toEditEmployee
  );

  return (
    <Form
      layout="vertical"
      size="large"
      className={`ant-form-custom ${isFormReadOnly ? 'ant-form-readOnly' : ''}`}
      form={form}
      initialValues={{
        id: employeeID,
        phone_1: contact && contact.phone_1,
        phone_2: contact && contact.phone_2,
        email: contact && contact.email,
        address_1: contact && contact.address_1,
        address_2: contact && contact.address_2,
        city: contact && contact.city,
        state: contact && contact.state,
        pin_code: contact && contact.pin_code,
        reference_name: contact && contact.reference_name,
        reference_contact: contact && contact.reference_contact,
      }}
      onFinish={(values) => {
        setIsFormReadOnly(!isFormReadOnly);
        onContactInfoUpdate(values);
      }}
    >
      <Row>
        <Col flex="auto" style={{ textAlign: 'right' }}>
          {ability.toEditEmployee && (
            <ActionButtons
              showEditBtn={isFormReadOnly}
              onEditClick={() => setIsFormReadOnly(!isFormReadOnly)}
              onCancelClick={() => {
                setIsFormReadOnly(!isFormReadOnly);
                form.resetFields();
              }}
            />
          )}
        </Col>
      </Row>
      {/* <Row justify="left">
              <Col xs={8}>
                <Form.List name="users">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, fieldKey, ...restField }) => (
                        <Space
                          key={key}
                          style={{ display: 'flex', marginBottom: 8 }}
                          align="baseline"
                        >
                          <Form.Item
                            {...restField}
                            name={[name, 'type']}
                            fieldKey={[fieldKey, 'type']}
                            rules={[
                              { required: true, message: 'Missing type' },
                            ]}
                          >
                            <Select placeholder="Please select" value="mobile">
                              <Select.Option value="mobile">
                                Mobile
                              </Select.Option>
                              <Select.Option value="work">Work</Select.Option>
                              <Select.Option value="home">Home</Select.Option>
                              <Select.Option value="other">Other</Select.Option>
                            </Select>
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, 'phoneNUmber']}
                            fieldKey={[fieldKey, 'phoneNUmber']}
                            rules={[
                              {
                                required: true,
                                message: 'Missing contact number',
                              },
                            ]}
                          >
                            <Input placeholder="Phone Number" />
                          </Form.Item>
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Space>
                      ))}
                      <Form.Item>
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                        >
                          Add Phone Number
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Col>
            </Row> */}
      <Row gutter={128}>
        <Col xs={24} md={12}>
          <Form.Item
            label="Phone 1"
            name="phone_1"
            rules={[{ required: true, message: 'Please input Phone 1!' }]}
          >
            <Input placeholder="Phone 1" disabled={isFormReadOnly} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label="Phone 2" name="phone_2">
            <Input placeholder="Phone 2" disabled={isFormReadOnly} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={128}>
        <Col xs={24} md={12}>
          <Form.Item
            label="Email"
            name="email"
            rules={[              
              {
                pattern: /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*$/,
                message: 'Please input valid Email!',
              },
            ]}
          >
            <Input placeholder="Email" disabled={isFormReadOnly} />
          </Form.Item>
        </Col>
      </Row>
      <Row style={{ marginTop: '1rem' }}>
        <Col xs={24}>{/* <h4>Contact Address <hr /></h4> */}</Col>
      </Row>
      <Row gutter={128}>
        <Col xs={24} md={12}>
          <Form.Item label="Address 1" name="address_1">
            <Input placeholder="Address 1" disabled={isFormReadOnly} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label="Address 2" name="address_2">
            <Input placeholder="Address 2" disabled={isFormReadOnly} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={128}>
        <Col xs={24} md={12}>
          <Form.Item label="City" name="city">
            <Input placeholder="City" disabled={isFormReadOnly} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label="State" name="state">
            <Select>
              <Option value="TN">Tamil Nadu</Option>
              <Option value="KL">Kerala</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={128}>
        <Col xs={24} md={12}>
          <Form.Item label="Pin Code" name="pin_code">
            <Input
              placeholder="Pin Code"
              disabled={isFormReadOnly}
              maxLength="6"
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}></Col>
      </Row>
      <Row gutter={128}>
        <Col xs={24} md={12}>
          <Form.Item label="Reference Name" name="reference_name">
            <Input placeholder="Reference Name" disabled={isFormReadOnly} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label="Reference Contact" name="reference_contact">
            <Input placeholder="Reference Contact" disabled={isFormReadOnly} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
    </Form>
  );
};

ContactInfo.defaultProps = {
  ability: {},
};

ContactInfo.propTypes = {
  employee: PropTypes.object.isRequired,
  onContactInfoUpdate: PropTypes.func.isRequired,
  ability: PropTypes.object.isRequired,
};

export default ContactInfo;
